
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { store } from "../../storeLogistica";
import _ from "lodash";
import VueSelect from "vue-select";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TableApp from "../../../../components/Table/Table3.vue"
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "app-nfe-form-documentosTab",
  components: {
    VueSelect,
    Plus,
    TableApp,
    TrashCanIcon,
  },
  directives: {
  },
  data() {
    return {
      store,
      selectedNFe: null,
      searchedNfes: [],
      windowWidth: window.innerWidth,
      documentosVinculados: [],
      fields: [
        {
          label: "Número",
          field: "numero",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Chave",
          field: "chave",
          slot: true,
          sortable: false,
          width: "40%",
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
        },
      ],
    }
  },
  mixins: [
    validationMixin,
    SistemaMixin,
  ],
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      const mdfeData = this.$route.params?.mdfeData?.mdfe;
      if(mdfeData){
        this.documentosVinculados = mdfeData.documentosVinculados
      }
    },
    onSearchNfe(search, loading) {
      if (search.length === 0) return;
      if (!/^[0-9]+$/.test(search)) {
        this.$toast.error('Insira apenas números para a busca!')
        return;
      }
      this.searchNfe(loading, search, this);
    },
    searchNfe: _.debounce(async (loading, numero, vm) => {
      if (loading) loading(true);
      try {
        const { data } = await vm.$http.post('/nfe/get-nfe-by-numero', { numero });
        vm.searchedNfes = [data]
      } catch (e) {
        console.log(e);
      }
      if (loading) loading(false);
    }, 1000),
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    addNfe(nfeToAdd){
      const isAlreadyAdded = this.documentosVinculados.find(doc => doc.id_nfe === nfeToAdd.id);
      if(isAlreadyAdded){
        this.$toast.warning('NFe ja adicionada!');
        return;
      }
      this.documentosVinculados = [...this.documentosVinculados, {
        chave: nfeToAdd.chave,
        tipo_chave: 1,
        tipo_nfe: nfeToAdd.tipoNF,
        id_nfe: nfeToAdd.id,
        numero: nfeToAdd.numero
      }]
      this.selectedNFe = null;
    },
    handleDeleteNfe(nfeToRemove){
      this.documentosVinculados = this.documentosVinculados.filter(doc => doc.id_nfe !== nfeToRemove.id_nfe)
    },
  },
  created() {
    this.getDataInit();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 4
    }
  },
  watch: {
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 5 && oldValue < newValue) {
        if(this.documentosVinculados.length === 0){
          this.$toast.error('Obrigatório ao menos um documento vinculado!')
          this.store.currentTab = oldValue;
          return;
        }
        this.store.formData = {
          ...this.store.formData,
          documentosVinculados: this.documentosVinculados,
        }
      }
    },
  }
}

